export default __webpack_public_path__ + "static/media/iconStarWhite.fe0af617.svg";